import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=64a58fbc&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/homepage.css?vue&type=style&index=0&id=64a58fbc&prod&scoped=true&lang=css&external"
import style1 from "@/assets/css/news-section.css?vue&type=style&index=1&id=64a58fbc&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a58fbc",
  null
  
)

export default component.exports